import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'
import { LocationOn } from '@material-ui/icons'

const useStyle = makeStyles((theme) => ({
  optionIcon: {
    color: theme.palette.primary.main,
    fontSize: 14,
    width: 14,
    marginRight: theme.spacing(2),
  },
  secondary: {
    fontSize: 14,
    color: '#c4c4c4',
  },
}))

export default function AddressOption({ option }) {
  const classes = useStyle()

  let {
    label,
    address: { city = '', country = '', state = '' },
  } = option

  let end = label.indexOf(city)
  if (end > 0) label = label.slice(0, end - 2)

  let location = city

  if (state) location += location ? ' - ' + state : state
  if (country) location += location ? ' - ' + country : country

  return (
    <Box display="flex" alignItems="center" style={{ paddingInline: 8, width: '100%' }}>
      <LocationOn className={classes.optionIcon} />
      <Box>
        <Typography>{label}</Typography>
        <Typography className={classes.secondary}>{location}</Typography>
      </Box>
    </Box>
  )
}
